function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { Layout, Menu, Drawer, Button, Statistic, Descriptions, DatePicker } from 'antd';
import { List, EmojiSmileFill } from 'react-bootstrap-icons';
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { Container, Col, Row } from 'react-bootstrap';
import Common from '../components/includes/Common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Header = Layout.Header,
    Content = Layout.Content,
    Footer = Layout.Footer,
    Sider = Layout.Sider;
var RangePicker = DatePicker.RangePicker;

var CompanyReports = function CompanyReports() {
  var navigate = useNavigate();

  var _useParams = useParams(),
      userid = _useParams.userid;

  var _useState = useState(Common.currentUser),
      _useState2 = _slicedToArray(_useState, 2),
      user = _useState2[0],
      setUser = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      authProcessing = _useState4[0],
      setAuthProcessing = _useState4[1];

  useEffect(function () {
    var uid = Common.currentUser != null ? Common.currentUser.id : userid;
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: uid
    }).then(function (response) {
      setAuthProcessing(false);

      if (response.data.authenticated == true) {
        setUser(response.data.user);
        localStorage.setItem('userData', JSON.stringify(response.data.user));
      } else {
        navigate('/');
      }
    })["catch"](function (error) {});

    if (user == null) {
      setUser(Common.currentUser);
    }
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: user != null ? /*#__PURE__*/_jsx(Layout, {
      style: {
        minHeight: '100vh'
      },
      children: /*#__PURE__*/_jsxs(Layout, {
        className: "site-layout",
        children: [/*#__PURE__*/_jsx(Header, {
          className: "site-layout-background",
          style: {
            padding: 0
          },
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 2,
                xs: 3,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    width: '80px'
                  },
                  children: /*#__PURE__*/_jsx("img", {
                    src: "drawables/gsl_logo.png",
                    style: {
                      width: '100%'
                    }
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 5,
                sm: 6,
                xs: 6,
                children: /*#__PURE__*/_jsx(RangePicker, {})
              }), /*#__PURE__*/_jsx(Col, {
                lg: {
                  span: 4,
                  offset: 0
                },
                md: {
                  span: 4,
                  offset: 0
                },
                sm: {
                  span: 4,
                  offset: 0
                },
                xs: {
                  span: 5,
                  offset: 0
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(EmojiSmileFill, {
                    size: 25
                  }), " ", user != null && ' ' + user.firstname, " , bonjour"]
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Content, {
          style: {
            margin: '0 16px',
            paddingTop: '30px'
          },
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(Row, {
              children: /*#__PURE__*/_jsxs(Col, {
                lg: 8,
                md: 9,
                children: [/*#__PURE__*/_jsx("div", {
                  className: "cool-radius",
                  style: {
                    backgroundColor: '#2658A4'
                  },
                  children: /*#__PURE__*/_jsx(Descriptions, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "INFOS Entreprise"
                    })
                  })
                }), /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 6,
                    md: 6,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      className: "cool-radius white-bg",
                      children: /*#__PURE__*/_jsx(Statistic, {
                        prefix: "GNF",
                        valueStyle: null,
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Facture totale"
                        }),
                        value: 2000000
                      })
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 6,
                    md: 6,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      className: "cool-radius white-bg",
                      children: /*#__PURE__*/_jsx(Statistic, {
                        valueStyle: null,
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Nbre Consultations"
                        }),
                        value: 20
                      })
                    })
                  })]
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx(Footer, {
          style: {
            textAlign: 'center'
          },
          children: "GuisoftLab \xA92022 Tous droits r\xE9serv\xE9s"
        })]
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};

export default CompanyReports;